import { gql } from '@apollo/client'

const SOPS_QUERY = gql`
  query sops {
    sops {
      id
      name
      link
    }
  }
`

export default SOPS_QUERY
